import {AxiosResponse} from 'axios'
import axiosApi from '../api/axios-api'

export default {
    auditLogFind(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/auditlog/find`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	auditLogExport(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/auditlog/export`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	auditLogGetActionComment(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/auditlog/getactioncomment`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
}
